export const valuesForAllTypes = [
  '10-K',
  '10-K/A',
  '10-K405',
  '10-K405/A',
  '10-KT',
  '10-KT/A',

  '10-Q',
  '10QSB',
  '10-QT/A',
  '10-QT',
  '10-Q/A',

  'ARS/A',
  'ARS',
  'AR',

  'QR',
  'QR/A',

  'SR',

  'TCFD Report',
  'Sustainability Report',
  'Environmental Report',
  'Corporate Governance Report',
  'Corporate Social Responsibility Report',
];

export const comparisonFileTypes = [
  '10-K',
  '10-K/A',
  '10-K405',
  '10-K405/A',
  '10-KT',
  '10-KT/A',

  '10-Q',
  '10QSB',
  '10-QT/A',
  '10-QT',
  '10-Q/A',
];

export const pressReleaseFileTypes = [
  '6-k',
  '6-K/A',

  '8-K15D5',
  '8-K12G3/A',
  '8-K12G3',
  '8-K12B/A',
  '8-K12B',
  '8-K/A',
  '8-K',
];

export const valuesForRecentEarningCalls = ['FMP-Transcript'];

export const FileTypes = {
  domestic: [
    {
      labelToShow: 'Scheduled Files',
      value: [...valuesForAllTypes],
      documentTypeGroup: 'all',
      index: 'fillings_sec*',
    },
    {
      labelToShow: 'Form 10-K Quintile',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K',
      index: 'fillings_sec_10K*',
    },
    {
      labelToShow: 'Form 10-Q Quintile',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q',
      index: 'fillings_sec_10Q*',
    },
    {
      labelToShow: 'Form 10-K',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K-ES',
      index: 'fillings_sec_10K*',
    },
    {
      labelToShow: 'Form 10-Q',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q-ES',
      index: 'fillings_sec_10Q*',
    },
    {
      labelToShow: 'Form 20-F',
      value: ['20-F', '20-F/A'],
      documentTypeGroup: '20-F',
      index: 'fillings_sec_20f*',
    },
    {
      labelToShow: 'Form 40-F',
      value: ['40-F'],
      documentTypeGroup: '40-F',
      index: 'fillings_sec_20f*',
    },
    {
      labelToShow: 'Form 6-K',
      value: ['6-k', '6-K/A'],
      documentTypeGroup: '6-K',
      index: 'fillings_sec_6k*',
    },
    {
      labelToShow: 'Form 8-K',
      value: ['8-K15D5', '8-K12G3/A', '8-K12G3', '8-K12B/A', '8-K12B', '8-K/A', '8-K'],
      documentTypeGroup: '8-K',
      index: 'fillings_sec_8k*',
    },
    {
      labelToShow: 'Earnings Call',
      value: ['FMP-Transcript'],
      documentTypeGroup: 'EC-FMP',
      index: 'fillings_sec_ecfmp*',
    },
    {
      labelToShow: 'Annual Report',
      value: ['ARS/A', 'ARS', 'AR'],
      documentTypeGroup: 'AR',
      index: 'fillings_global_ar*',
      countryCode: 'us',
    },
    {
      labelToShow: 'Quarterly Report',
      value: ['QR', 'QR/A'],
      documentTypeGroup: 'QR',
      index: 'fillings_global_qr*',
      countryCode: 'us',
    },
    {
      labelToShow: 'Semi-Annual Report',
      value: ['SR'],
      documentTypeGroup: 'SR',
      index: 'fillings_global_sr*',
      countryCode: 'us',
    },
    {
      labelToShow: 'ESG',
      value: [
        'TCFD Report',
        'Sustainability Report',
        'Environmental Report',
        'Corporate Governance Report',
        'Corporate Social Responsibility Report',
      ],
      documentTypeGroup: 'ESG',
      index: 'fillings_global_esg*',
      countryCode: 'us',
    },
  ],

  global: [
    {
      labelToShow: 'Scheduled Files',
      value: [...valuesForAllTypes],
      documentTypeGroup: 'all',
      index: 'fillings_sedar*',
    },
    {
      labelToShow: 'Form 10-K Quintile',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K',
      index: 'fillings_sec_10K*',
    },
    {
      labelToShow: 'Form 10-Q Quintile',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q',
      index: 'fillings_sec_10Q*',
    },
    {
      labelToShow: 'Form 10-K',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K-ES',
      index: 'fillings_sec_10K*',
      countryCode: 'ca',
    },
    {
      labelToShow: 'Form 10-Q',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q-ES',
      index: 'fillings_sec_10Q*',
      countryCode: 'ca',
    },
    {
      labelToShow: 'Form 20-F',
      value: ['20-F', '20-F/A'],
      documentTypeGroup: '20-F',
      index: 'fillings_sec_20f*',
      countryCode: 'ca',
    },
    {
      labelToShow: 'Form 40-F',
      value: ['40-F'],
      documentTypeGroup: '40-F',
      index: 'fillings_sec_20f*',
    },
    {
      labelToShow: 'Form 8-K',
      value: ['8-K15D5', '8-K12G3/A', '8-K12G3', '8-K12B/A', '8-K12B', '8-K/A', '8-K'],
      documentTypeGroup: '8-K',
      index: 'fillings_sec_8k*',
      countryCode: 'ca',
    },
    {
      labelToShow: 'Annual Report',
      value: ['ARS/A', 'ARS', 'AR'],
      documentTypeGroup: 'AR',
      index: 'fillings_global_ar*',
      sourceName: 'SEDAR',
    },
    {
      labelToShow: 'Quarterly Report',
      value: ['QR', 'QR/A'],
      documentTypeGroup: 'QR',
      index: 'fillings_global_qr*',
      sourceName: 'SEDAR',
    },
    {
      labelToShow: 'Semi-Annual Report',
      value: ['SR'],
      documentTypeGroup: 'SR',
      index: 'fillings_global_sr*',
      sourceName: 'SEDAR',
    },
    {
      labelToShow: 'ESG',
      value: [
        'TCFD Report',
        'Sustainability Report',
        'Environmental Report',
        'Corporate Governance Report',
        'Corporate Social Responsibility Report',
      ],
      documentTypeGroup: 'ESG',
      index: 'fillings_global_esg*',
      countryCode: 'ca',
    },
    {
      labelToShow: 'Others',
      value: ['FIN-SUPP', 'Other Financials'],
      documentTypeGroup: 'Others',
      index: 'fillings_global_finsupp*,fillings_global_othfin*',
      sourceName: 'SEDAR',
    },
    // {
    //   labelToShow: 'Financial Supplement',
    //   value: ['FIN-SUPP'],
    //   documentTypeGroup: 'FIN-SUPP',
    //   index: 'fillings_global_finsupp*',
    //   sourceName: 'SEDAR'
    // },
    // {
    //   labelToShow: 'Other Financials',
    //   value: ['Other Financials'],
    //   documentTypeGroup: 'OTH-FIN',
    //   index: 'fillings_global_othfin*',
    //   sourceName: 'SEDAR'
    // }
  ],

  newGlobal: [
    {
      labelToShow: 'Scheduled Files',
      value: [...valuesForAllTypes],
      documentTypeGroup: 'all',
      index: 'fillings_*',
    },
    {
      labelToShow: 'Form 10-K Quintile',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K',
      index: 'fillings_sec_10K*',
    },
    {
      labelToShow: 'Form 10-Q Quintile',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q',
      index: 'fillings_sec_10Q*',
    },
    {
      labelToShow: 'Form 10-K',
      value: ['10-K', '10-K/A', '10-K405', '10-K405/A', '10-KT', '10-KT/A'],
      documentTypeGroup: '10-K-ES',
      index: 'fillings_sec_10K*',
    },
    {
      labelToShow: 'Form 10-Q',
      value: ['10-Q', '10QSB', '10-QT/A', '10-QT', '10-Q/A'],
      documentTypeGroup: '10-Q-ES',
      index: 'fillings_sec_10Q*',
    },
    {
      labelToShow: 'Form 20-F',
      value: ['20-F', '20-F/A'],
      documentTypeGroup: '20-F',
      index: 'fillings_sec_20f*',
    },
    {
      labelToShow: 'Form 40-F',
      value: ['40-F'],
      documentTypeGroup: '40-F',
      index: 'fillings_sec_20f*',
    },
    {
      labelToShow: 'Form 6-K',
      value: ['6-k', '6-K/A'],
      documentTypeGroup: '6-K',
      index: 'fillings_sec_6k*',
    },
    {
      labelToShow: 'Form 8-K',
      value: ['8-K15D5', '8-K12G3/A', '8-K12G3', '8-K12B/A', '8-K12B', '8-K/A', '8-K'],
      documentTypeGroup: '8-K',
      index: 'fillings_sec_8k*',
    },
    {
      labelToShow: 'Earnings Call',
      value: ['FMP-Transcript'],
      documentTypeGroup: 'EC-FMP',
      index: 'fillings_sec_ecfmp*',
    },
    {
      labelToShow: 'Annual Report',
      value: ['ARS/A', 'ARS', 'AR'],
      documentTypeGroup: 'AR',
      index: 'fillings_global_ar*',
    },
    {
      labelToShow: 'Quarterly Report',
      value: ['QR', 'QR/A'],
      documentTypeGroup: 'QR',
      index: 'fillings_global_qr*',
    },
    {
      labelToShow: 'Semi-Annual Report',
      value: ['SR'],
      documentTypeGroup: 'SR',
      index: 'fillings_global_sr*',
    },
    {
      labelToShow: 'ESG',
      value: [
        'TCFD Report',
        'Sustainability Report',
        'Environmental Report',
        'Corporate Governance Report',
        'Corporate Social Responsibility Report',
      ],
      documentTypeGroup: 'ESG',
      index: 'fillings_global_esg*',
    },
    {
      labelToShow: 'Others',
      value: ['FIN-SUPP', 'Other Financials'],
      documentTypeGroup: 'Others',
      index: 'fillings_global_finsupp*,fillings_global_othfin*',
    },
    // {
    //   labelToShow: 'Financial Supplement',
    //   value: ['FIN-SUPP'],
    //   documentTypeGroup: 'FIN-SUPP',
    //   index: 'fillings_global_finsupp*'
    // },
    // {
    //   labelToShow: 'Other Financials',
    //   value: ['Other Financials'],
    //   documentTypeGroup: 'OTH-FIN',
    //   index: 'fillings_global_othfin*'
    // }
  ],
};

export const assetClasses = {
  domestic: [
    { label: 'Stock', value: 2 },
    { label: 'Forex', value: 5 },
    { label: 'Future', value: 4 },
    { label: 'ETF', value: 6 },
    { label: 'Spac', value: 14 },
    { label: 'Penny', value: 20 },
  ],

  global: [{ label: 'TSX', value: 15 }],

  newGlobal: [
    { label: 'LSE', value: 9 },
    { label: 'NSE', value: 16 },
    { label: 'ASX', value: 19 },
    { label: 'Pan European', value: 18 },
  ],
};
